export const KeyCodes = {
  tab: 9,
  enter: 13,
  shift: 16,
  esc: 27,
  spaceBar: 32,
  arrowUp: 38,
  arrowDown: 40,
  arrowLeft: 37,
  arrowRight: 39,
  sKey: 83,
};

export const EVENTS = {
  change: 'change',
  click: 'click',
  dragleave: 'dragleave',
  dragover: 'dragover',
  drop: 'drop',
  focus: 'focus',
  keydown: 'keydown',
  keyup: 'keyup',
  submit: 'submit',
  input: 'input',
  mouseover: 'mouseover',
  mouseleave: 'mouseleave',
  mousedown: 'mousedown',
  resize: 'resize',
  dirtyStateCheck: 'DIRTY_STATE_CHECK',
  dirtyStateRevert: 'DIRTY_STATE_REVERT',
  contextBarOn: 'CONTEXT_BAR_ON_EVENT',
  contextBarOff: 'CONTEXT_BAR_OFF_EVENT',
  dateRangeSelected: 'DATE_RANGE_SELECTED',
  lockFormSubmit: 'FORM_LOCKED',
  unlockFormSubmit: 'FORM_UNLOCKED',
  uiModalManagerLoaded: 'UI_MODAL_MANAGER_LOADED',
};

export const QUICK_SEARCH = {
  ES_DEFAULT_PRIORITY: 100,
  YML_DEFAULT_PRIORITY: 200,
  DOCS_DEFAULT_PRIORITY: 1000,
  DOCS_DEFAULT_TITLE: 'Docs',
};

export const DATE_FORMATS = {
  POLARIS_SHORT: 'MMM D, YYYY',
};

export const DEBOUNCE_THREE_SECONDS = 3000;

export const PAGE_SIZE = 20;
